<template>
  <div class="policy-container">
    <div class="policy-card">
      <h1>Политика конфиденциальности</h1>
      <p class="intro">
        Настоящая политика объясняет, как мы используем файлы cookie и обрабатываем ваши персональные данные при
        использовании нашего сайта Estimator24.
      </p>

      <h2>1. Что такое файлы cookie</h2>
      <p>
        Cookie — это небольшие текстовые файлы, которые сохраняются на вашем устройстве при посещении сайта.
        Они помогают нам улучшить пользовательский опыт, анализировать посещаемость и сохранять ваши настройки.
      </p>

      <h2>2. Как мы используем cookie</h2>
      <ul>
        <li>Для обеспечения корректной работы сайта (сессии, авторизация и настройки языка).</li>
        <li>Для анализа статистики посещаемости и улучшения контента.</li>
        <li>Для запоминания пользовательских предпочтений и параметров поиска.</li>
      </ul>

      <h2>3. Управление cookie</h2>
      <p>
        Вы можете в любой момент изменить свои настройки cookie через настройки браузера или обновить выбор на сайте.
        Если вы отклоните использование cookie, некоторые функции сайта могут работать некорректно.
      </p>

      <h2>4. Сбор и использование данных</h2>
      <p>
        Мы не передаем ваши данные третьим лицам, кроме случаев, предусмотренных законом. Собранная информация
        используется исключительно для статистического анализа и улучшения работы сервиса.
      </p>

      <h2>5. Безопасность данных</h2>
      <p>
        Мы принимаем все необходимые меры для защиты ваших данных от несанкционированного доступа, изменения,
        раскрытия или уничтожения.
      </p>

      <h2>6. Контакты</h2>
      <p>
        Если у вас есть вопросы о нашей политике конфиденциальности, свяжитесь с нами по адресу:<br />
        <strong>privacy@estimator24.com</strong>
      </p>

      <router-link to="/" class="back-btn">← Вернуться на главную</router-link>
    </div>
  </div>
</template>

<script setup>
// компонент статичный — логика не требуется
</script>

<style scoped>
.policy-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 80px 20px;
  background: #f9fafb;
  min-height: 100vh;
}

.policy-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  width: 100%;
  padding: 40px 50px;
  color: #333;
  line-height: 1.6;
  animation: fadeIn 0.4s ease;
}

.policy-card h1 {
  font-size: 26px;
  margin-bottom: 20px;
  color: #111;
}

.policy-card h2 {
  font-size: 18px;
  margin-top: 25px;
  margin-bottom: 10px;
  color: #222;
}

.policy-card p {
  font-size: 15px;
  color: #555;
}

.policy-card ul {
  margin-left: 20px;
  color: #555;
  font-size: 15px;
}

.policy-card li {
  margin-bottom: 6px;
}

.intro {
  margin-bottom: 25px;
}

.back-btn {
  display: inline-block;
  margin-top: 30px;
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.back-btn:hover {
  text-decoration: underline;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
